import { render, staticRenderFns } from "./UseRateInfo.vue?vue&type=template&id=9bbc3bd6&"
import script from "./UseRateInfo.vue?vue&type=script&lang=js&"
export * from "./UseRateInfo.vue?vue&type=script&lang=js&"
import style0 from "./UseRateInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports